export default {
    'android-app': 'Radio1.7 na Androida',
    'discord-bot': 'Zaproś naszego bota na swój serwer',
    'no-data': 'Brak danych',
    'what-we-played': 'Co graliśmy?'
}
